module.exports = __webpack_public_path__ + "static/media/commentary on sixteen precepts.e6adc789.md";